import { useState } from 'react';
import { Card, CardProps, Collapse } from 'react-bootstrap';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';

/**
 * Card Accordion
 */
export default function CardAccordion({
  open = false,
  bg,
  border,
  className,
  text,
  headerClassName,
  bodyClassName,
  title,
  children,
  disableCollapse = false,
}: {
  /** Default open state */
  open?: boolean;
  bg?: string;
  border?: string;
  className?: string;
  text?: CardProps['text'];
  headerClassName?: string;
  bodyClassName?: string;
  title: string;
  children: any;
  disableCollapse?: boolean;
}) {
  const [isOpen, setOpen] = useState(open);

  return (
    <Card bg={bg} border={border} className={className} text={text}>
      <Card.Header
        onClick={() => {
          if (!disableCollapse) setOpen(!isOpen);
        }}
        aria-expanded={isOpen}
        className={headerClassName}
      >
        {!disableCollapse && (
          <span>{isOpen ? <MdExpandLess /> : <MdExpandMore />} </span>
        )}
        {title}
      </Card.Header>
      <Collapse in={isOpen}>
        <div>
          <Card.Body className={bodyClassName}>{children}</Card.Body>
        </div>
      </Collapse>
    </Card>
  );
}
